// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ExportDataDownloadRequestFromJSON(json) {
    return {
        'azureStorageKey': !exists(json, 'azureStorageKey') ? undefined : json['azureStorageKey'],
    };
}
export function ExportDataDownloadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'azureStorageKey': value.azureStorageKey,
    };
}
